<div class="content center-content">
    <div class="column-flex">
        <ng-container *ngIf="!isLoadingChannels && channels">
            <div class="title-container">
                <div class="title">
                    {{
                        multipleSelection
                            ? ('channel-search.dialog.title.multiple' | translate)
                            : ('channel-search.dialog.title' | translate)
                    }}
                </div>
                <div class="subtitle">
                    {{
                        multipleSelection
                            ? ('channel-search.dialog.subtitle.multiple' | translate)
                            : ('channel-search.dialog.subtitle' | translate)
                    }}
                </div>
            </div>

            <app-channel-text-input
                class="search-channel-input"
                [name]="channel - search"
                label="channel-search.dialog.input.placeholder"
                [value]="inputChannel"
                (onInputChange)="inputChannel = $event.value; searchChannels()"
                [maxLength]="32">
            </app-channel-text-input>

            <app-list-bubble-selector
                #typesSelector
                [shouldDisable]="shouldDisableTypes"
                [title]="'channel-search.dialog.channel-type.title'"
                [elementList]="filteredTypesList"
                [listBubbleType]="'type'"
                [selectedElements]="selectedTypes"
                (onElementSelected)="updateTypesSet($event)"></app-list-bubble-selector>
            <app-list-bubble-selector
                #categoriesSelector
                [title]="'channel-search.dialog.category.title'"
                [elementList]="channelCategories"
                [listBubbleType]="'category'"
                (onElementSelected)="updateFilteredCategories($event)"></app-list-bubble-selector>
            <app-list-bubble-selector
                #groupsSelector
                [title]="'channel-search.dialog.group.title'"
                [elementList]="filteredGroupList"
                [listBubbleType]="'group'"
                (onElementSelected)="updateFilteredGroups($event)"></app-list-bubble-selector>
            <app-channel-search-table
                style="width: 100%; overflow-y: scroll"
                [filteredChannelList]="filteredChannelList"
                [selectedChannels]="selectedChannels"
                [multipleSelection]="multipleSelection"
                [preSelectedChannelsCount]="preSelectedChannelsCount"
                (onChannelSelected)="handleChannelSelected($event)"></app-channel-search-table>
            <div class="buttons-container">
                <ng-container *ngIf="!has2Steps; else stepIndicator">
                    <div class="button reset" (click)="reset()">
                        {{ 'channel-search.dialog.button.reset' | translate }}
                    </div>
                </ng-container>

                <ng-template #stepIndicator>
                    <div class="step">
                        {{ 'channel-search.dialog.button.step' | translate }}
                    </div>
                </ng-template>

                <div class="right-buttons-container">
                    <div class="button cancel" (click)="cancel()">
                        {{ 'channel-search.dialog.button.cancel' | translate }}
                    </div>
                    <div
                        class="button select"
                        [ngClass]="{
                            'disabled-button':
                                !selectedChannels?.[0] || assignedChannel?.id === selectedChannels[0]?.id,
                        }"
                        (click)="selectChannel()"
                        data-cy="select-channel-window-select-button">
                        {{
                            has2Steps
                                ? ('channel-search.dialog.button.next' | translate)
                                : ('channel-search.dialog.button.select' | translate)
                        }}
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!isLoadingChannels && !channels">
            <div class="title-container empty-vessel">
                <div class="title">
                    {{ 'channel-search.dialog.no-chanels.title' | translate }}
                </div>
                <div class="subtitle">
                    {{ 'channel-search.dialog.no-chanels.subtitle' | translate }}
                </div>
            </div></ng-container
        >
        <ng-container *ngIf="isLoadingChannels">
            <app-loading-spinner class="spinner-component"></app-loading-spinner>
        </ng-container>
    </div>
</div>
